import React, {useState, FunctionComponent} from 'react';
import { Icon } from '@/components';
import StylesType from '@/types/StylesType';
import classnames from 'classnames';
import './style';
import log from '@/utils/log';

export interface CustomerProps extends StylesType{
    /** icon类型 */
    readonly type?: string;
    /** 名称 */
    readonly name?: string;
    /** 客服url */
    readonly url?: string;
}

export interface CustomerModalProps extends StylesType{
    readonly url?: string;
    onClose?: () => void;
    visible?: boolean;
}

export const Customer: FunctionComponent<CustomerProps> = props => {
  
    const {prefixCls,type,className,style,name,url} = props;
    const [visible, setVisible] = useState(false);
    const handleIconClick = () => {
      log({eventId: 'E2700', pageId: 'P25', ext: '开'})
      setVisible(true)
    }
    const onClose = () => setVisible(false);
    
    return (
        <div style={style} className={classnames(prefixCls,className)}>
            <Icon onClick={handleIconClick} className={classnames(`${prefixCls}-icon`)} type={type}></Icon>
            <span className={classnames(`${prefixCls}-name`)}>{name}</span>
            <CustomerModal prefixCls={prefixCls} url={url} onClose={onClose} visible={visible} />
        </div>
    )
  
}

export const CustomerModal: React.FC<CustomerModalProps> = props => {
    const {prefixCls, url, onClose, visible} = props;
    if (!visible) return <></>
    return (
        <div className={classnames(`${prefixCls}-layer`,{[`${prefixCls}-visible`]: visible})}>
            <div className={`${prefixCls}-online`}>
                <Icon className={`${prefixCls}-close`} type='iconclose' onClick={onClose} />
                <iframe className={`${prefixCls}-iframe`} title='客服'  src={url} ></iframe>
            </div>
        </div>
    )
}

Customer.defaultProps = {
    type: 'iconcustomer',
    prefixCls: 'gc-resident-customer',
    name: '咨询',
    url: 'https://cschat-ccs.aliyun.com/index.htm?tntInstId=ssQ_r1FN&scene=SCE00005109#/',
}

export default Customer;
